// extracted by mini-css-extract-plugin
export default {"splashScreen":"loadingStyle_splashScreen__gS6gc","ldsDualRing":"loadingStyle_ldsDualRing__QRD6Q"};